export default __webpack_public_path__ + "static/media/everything_else.ce1cc4be.jpg";